// extracted by mini-css-extract-plugin
module.exports = {"container":"NewListing_container__QSEux","heading":"NewListing_heading__h5rMk","noResult":"NewListing_noResult__LBU6N","skeleton":"NewListing_skeleton__3HjYP"};